import { Button, Form, Input, Modal } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { brandModalSliceDispatch, pickAFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";

function BrandModal() {
    const currentBrands = useSelector((state: any) => state.pickAFile.brandList);
    const currentServiceQuestionBrand = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);

    const open = useSelector((state: any) => state.brandModal.open);
    const brandToAdd = useSelector((state: any) => state.brandModal.brandToAdd);

    const addModal = useSelector((state: any) => state.brandViewer.addModal);
    const editModal = useSelector((state: any) => state.brandViewer.editModal);
    const currentBrand = useSelector((state: any) => state.brandViewer.currentBrand);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    let brandValuesToShow = currentBrand;

    let adder = AddABrand;
    let editor = brandEditor;

    let currentBrandsIds = currentBrands.map(b => {
        return b.brandId;
    });

    function brandEditor(oldBrandId: any, newBrand: any) {
        let filteredBrands = DeleteABrand(oldBrandId, false)
        AddABrand(filteredBrands, newBrand)

        let updatedQuestionServiceBrands = currentServiceQuestionBrand.map((x: any) => x.brandId == oldBrandId ? { ...x, ['brandId']: newBrand.brandId } : x);
        dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: updatedQuestionServiceBrands });
    }

    function AddABrand(oldList: any, newBrand: any) {
        let listToUse: any[] = [];
        if (oldList) {
            listToUse = oldList ?? listToUse;
        } else {
            listToUse = currentBrands ?? listToUse
        }

        listToUse.push(newBrand)
        dispatch({ type: pickAFileSliceDispatch.setBrandList, payload: listToUse })

        let tempBrandDropDownList = listToUse?.map((b: any) => {
            return ({ key: b.brandId, label: b.brandName, value: b.brandId })
        })

        dispatch({ type: pickAFileSliceDispatch.setBrandDropDownList, payload: tempBrandDropDownList })

        CreateContentsFromStates({ brandList: listToUse });
    }

    function DeleteABrand(idToDelete: any, updateState: boolean = true) {
        let filteredBrands = currentBrands.filter((brand: any) => brand.brandId != parseInt(idToDelete) || brand.brandId != idToDelete);
        
        if (updateState) {
            dispatch({ type: pickAFileSliceDispatch.setBrandList, payload: filteredBrands })

            let filteredServiceQuestionBrands = currentServiceQuestionBrand;
            filteredServiceQuestionBrands = filteredServiceQuestionBrands.filter((sqb: any) => sqb.brandId != parseInt(idToDelete))

            dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: filteredServiceQuestionBrands })

            CreateContentsFromStates({ brandList: filteredBrands });
        }

        return filteredBrands;
    }

    const onSubmit = () => {
        //We are adding a new one
        if (addModal) {
            adder(null, brandToAdd)
        }

        //We are editing one
        if (editModal) {
            editor(currentBrand.brandId, brandToAdd)
        }

        dispatch({ type: brandModalSliceDispatch.setOpen, payload: false })
    }

    const onCancel = () => {
        dispatch({ type: brandModalSliceDispatch.setOpen, payload: false })
    }

    const onChange = (event) => {
        //NOTE: Change brandIds to integers
        let valueToUse = event.target.value;
        if (event.target.id == "brandId") {
            valueToUse = parseInt(event.target.value);
        }

        dispatch({ type: brandModalSliceDispatch.setBrandToAdd, payload: { ...brandToAdd, [event.target.id]: valueToUse } })
    }


    return (
        <Modal
            title="Brand Details"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
            onCancel={onCancel}
        >
            <Form
                onFinish={onSubmit}
                preserve={false}
                initialValues={{
                    ["Brand ID"]: brandValuesToShow.brandId,
                    ["Brand Name"]: brandValuesToShow.brandName
                }}
            >
                <Form.Item rules={[{ required: true }, {
                    validator(rule, value) {
                        return new Promise((resolve, reject) => {
                            if (addModal) {
                                if (currentBrandsIds?.filter(x => x == value).length == 1) {
                                    reject('There is already a brand with ID ' + value + '.');
                                }
                                else {
                                    resolve(undefined);
                                }
                            }
                            else if (editModal) {
                                if (currentBrandsIds?.filter(x => x == value).length == 1 && currentBrand.brandId != value) {
                                    reject('There is already a brand with ID ' + value + '.');
                                }
                                else {
                                    resolve(undefined);
                                }
                            }
                            else {
                                resolve(undefined);
                            }
                        })
                    }
                }]} name="Brand ID" label="Brand ID">
                    <Input id="brandId" type="number" placeholder='Brand ID' defaultValue={brandValuesToShow.brandId} onChange={onChange} />
                </Form.Item>
                <Form.Item rules={[{ required: true }]} name="Brand Name" label="Brand Name">
                    <Input id="brandName" placeholder='Brand Name' defaultValue={brandValuesToShow.brandName} onChange={onChange} />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}

export default BrandModal;